import { ConfirmModal } from '@/shared/ui';
import useCheckSavePrompt from './useCheckSavePrompt';

export type CheckSavePromptProps = {
  condition: () => boolean;
  isNotEdit?: boolean;
};

/**
 * Guards navigation away from a report that still has unsaved changes. Uses useCheckSavePrompt to decide when the prompt is raised and renders a confirm modal whose Yes leaves the page and whose No cancels the navigation.
 *
 * @param condition - When true, navigation away should be intercepted.
 * @param isNotEdit - Read-only flag forwarded to the prompt hook.
 * @returns The rendered unsaved-changes confirm modal.
 */
const CheckSavePrompt = ({ condition, isNotEdit }: CheckSavePromptProps) => {
  const { showPrompt, handleYes, handleCancel } = useCheckSavePrompt({ condition, isNotEdit });

  return (
    <ConfirmModal
      isOpen={showPrompt}
      onClickLeftButton={handleCancel}
      onClickRightButton={handleYes}
      leftButtonName="No"
      rightButtonName="Yes"
      title="Unsaved changes"
      question="There are unsaved changes. Are you sure you want to quit?"
      isRedBtn={false}
    />
  );
};

export default CheckSavePrompt;
